import Vue from 'vue';

export function $t(key) {
  return Vue.prototype.$t(key);
}